(() => {
	window.addEventListener('load', () => {
		if (window.location.hash) {
			let hash = window.location.hash;
			hash = hash.replace('#', '');

			const target = document.getElementById(hash);
			if (!target) return;

			const initialPosition = window.scrollY;

			animateScroll({
				targetPosition: target.offsetTop,
				initialPosition,
				duration: 600
			});
		}
	});

	document.addEventListener('DOMContentLoaded', () => {
		const links = document.querySelectorAll('a');

		links.forEach(link => {
			link.addEventListener('click', event => {
				// eslint-disable-next-line prefer-destructuring
				let hash = event.target.hash;
				if(!hash) return;
				hash = hash.replace('#', '');
				
				const target = document.getElementById(hash);
				if(!target) return;

				event.preventDefault();
				const initialPosition = window.scrollY;

				animateScroll({
					targetPosition: target.offsetTop,
					initialPosition,
					duration: 600
				});

			});
		});
	});


	

	const pow = Math.pow;

	function easeOutQuart(x) {
		return 1 - pow(1 - x, 4);
	}

	const animateScroll = ({ targetPosition, initialPosition, duration }) => {
		let start;
		let position;
		let animationFrame;

		const requestAnimationFrame = window.requestAnimationFrame;
		const cancelAnimationFrame = window.cancelAnimationFrame;

		const headers = [...document.querySelectorAll('.header')];
		const activeHeader = headers.find(header => {
			return window.getComputedStyle(header, null).display !== 'none';
		});

		if(!activeHeader) {
			return;
		}

		const stickyHeader = activeHeader.querySelector('.header__stickyheader-container');
		let headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;

		const maxAvailableScroll = document.documentElement.scrollHeight - document.documentElement.clientHeight;
		targetPosition = targetPosition - headerHeight;

		const amountOfPixelsToScroll = initialPosition - targetPosition;

		function step(timestamp) {
			if (start === undefined) {
				start = timestamp;
			}

			const elapsed = timestamp - start;
			const relativeProgress = elapsed / duration;
			const easedProgress = easeOutQuart(relativeProgress);
			position = initialPosition - amountOfPixelsToScroll * Math.min(easedProgress, 1);
			window.scrollTo(0, position);

			if (initialPosition !== maxAvailableScroll && window.scrollY === maxAvailableScroll) {
				cancelAnimationFrame(animationFrame);
				return;
			}

			if (elapsed < duration) {
				animationFrame = requestAnimationFrame(step);
			}
		}
		animationFrame = requestAnimationFrame(step);
	};

})();
